module.exports = "/static/assets/4a3e75a918bb16870f05d1fff7fdc7d2.gif";